import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getNotificationTemplates = async (token) => {
    log("welcome in getNotificationTemplates")

    if (!token || token === "") {
        return {error: true, message: "No token provided", templates: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_notification_templates_api'
        const result = await axios.get(url, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in getNotificationTemplates")
        log(err)
        error.value = err.message
        return {error: true, message: "Error loading notification templates", templates: []}
    }
}

export const addNotificationTemplate = async (token, data) => {
    log("welcome in addNotificationTemplate")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_notification_template_api'
        const payload = {
            event_name: data.event_name,
            event_category: data.event_category,
            event_label: data.event_label,
            notification_subject: data.notification_subject,
            notification_body: data.notification_body,
            email_subject: data.email_subject,
            email_body: data.email_body,
            available_variables: data.available_variables,
            active: data.active !== false
        }

        const result = await axios.post(url, payload, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in addNotificationTemplate")
        log(err)
        error.value = err.message
        return {error: true, message: "Error adding notification template"}
    }
}

export const updateNotificationTemplate = async (token, data) => {
    log("welcome in updateNotificationTemplate")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_notification_template_api'
        const payload = {
            id: data.id,
            event_name: data.event_name,
            event_category: data.event_category,
            event_label: data.event_label,
            notification_subject: data.notification_subject,
            notification_body: data.notification_body,
            email_subject: data.email_subject,
            email_body: data.email_body,
            available_variables: data.available_variables,
            active: data.active
        }

        const result = await axios.put(url, payload, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in updateNotificationTemplate")
        log(err)
        error.value = err.message
        return {error: true, message: "Error updating notification template"}
    }
}

export const deleteNotificationTemplate = async (token, id) => {
    log("welcome in deleteNotificationTemplate")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_notification_template_api'
        const result = await axios.delete(url, {headers: headers, data: {id: id}})
        return result.data
    } catch (err) {
        log("Error in deleteNotificationTemplate")
        log(err)
        error.value = err.message
        return {error: true, message: "Error deleting notification template"}
    }
}

export default () => {
    return {
        error,
        getNotificationTemplates,
        addNotificationTemplate,
        updateNotificationTemplate,
        deleteNotificationTemplate
    }
}
